import { render, staticRenderFns } from "./DepartmentSearch.vue?vue&type=template&id=0fbf05ac"
import script from "./DepartmentSearch.vue?vue&type=script&lang=js"
export * from "./DepartmentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports